export const configCloseForm = () =>  ({ showForm: false});
